import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  updateDoc,
  doc,
  onSnapshot,
} from "firebase/firestore";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
import "jspdf-autotable";
import "../styles/Leave.css";
import { deleteDoc } from "firebase/firestore";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


const LeaveManagement = () => {
  const [form, setForm] = useState({
  hid: "",
  name: "",
  totalLeave: "",
  approvedLeave: "",
  remainingLeave: "",
  leaveDate: "",
  leaveType: ""
});

  const [employees, setEmployees] = useState([]);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [leaveRecords, setLeaveRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [sortKey, setSortKey] = useState("leaveDate");
  const [sortAsc, setSortAsc] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);


  useEffect(() => {
    const fetchEmployees = async () => {
      const snapshot = await getDocs(collection(db, "employees"));
      setEmployees(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchEmployees();
  }, []);

  useEffect(() => {
  const fetchLeaveRecords = async () => {
    const snapshot = await getDocs(collection(db, "leaveRecords"));
    const records = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    // Sort by name ascending (A–Z)
    const sortedByName = records.sort((a, b) => a.name.localeCompare(b.name));

    setLeaveRecords(sortedByName);
    setFilteredRecords(sortedByName);
    setSortKey("name");      // Optional: reflect sort state
    setSortAsc(true);        // Optional: reflect ascending direction
  };
      fetchLeaveRecords();
    }, []);


  useEffect(() => {
  const emp = employees.find(e => e.hid === form.hid);
  if (emp) setForm(prev => ({ ...prev, name: emp.name }));
}, [form.hid, employees]);


  useEffect(() => {
  const total = parseInt(form.totalLeave) || 0;
  const approved = parseInt(form.approvedLeave) || 0;

  const isDutyPaid = form.leaveType === "Reason";
  const remaining = isDutyPaid ? total : total - approved;

  setForm(prev => ({
    ...prev,
    remainingLeave: remaining >= 0 ? remaining : 0
  }));
}, [form.totalLeave, form.approvedLeave, form.leaveType]);


  // useEffect(() => {
  //   const unsubscribe = onSnapshot(collection(db, "leaveRequests"), (snapshot) => {
  //     const requests = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  //     if (requests.length) alert("New leave request received!");
  //     setLeaveRequests(requests);
  //   });
  //   return () => unsubscribe();
  // }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
  e.preventDefault();

  if (isEditing) {
    const docRef = doc(db, "leaveRecords", editId);
    await updateDoc(docRef, form);
    alert("Leave record updated!");
    setIsEditing(false);
    setEditId(null);
  } else {
    await addDoc(collection(db, "leaveRecords"), form);
    alert("Leave recorded!");
  }

  // Clear form
  setForm({ hid: "", name: "", totalLeave: "", approvedLeave: "", remainingLeave: "", leaveDate: "" });

  // Refresh data
  const snapshot = await getDocs(collection(db, "leaveRecords"));
  const records = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  setLeaveRecords(records);
  setFilteredRecords(records);
};


  const approveRequest = async (req) => {
    const emp = await getDocs(query(collection(db, "leaveRecords"), where("hid", "==", req.hid)));
    const leaveDoc = emp.docs[0];
    if (leaveDoc) {
      const ref = doc(db, "leaveRecords", leaveDoc.id);
      await updateDoc(ref, {
        approvedLeave: parseInt(leaveDoc.data().approvedLeave || 0) + parseInt(req.requestedDays),
      });
    }
    alert("Leave approved and updated!");
  };

  const handleSearch = e => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    const filtered = leaveRecords.filter(r =>
      r.name.toLowerCase().includes(term) ||
      r.epfOrPid.toLowerCase().includes(term)
    );
    setFilteredRecords(filtered);
    setCurrentPage(1);
  };

  const handleSort = key => {
    const sorted = [...filteredRecords].sort((a, b) => {
      if (a[key] < b[key]) return sortAsc ? -1 : 1;
      if (a[key] > b[key]) return sortAsc ? 1 : -1;
      return 0;
    });
    setFilteredRecords(sorted);
    setSortKey(key);
    setSortAsc(!sortAsc);
  };

  const exportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredRecords);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Room Records");
    XLSX.writeFile(workbook, "hotel_rooms.xlsx");
  };

 const exportPDF = () => {
  const docPDF = new jsPDF();
  docPDF.text("Room Records", 10, 10);

  const rows = filteredRecords.map(r => [
  r.hid,
  r.name,
  r.totalLeave,
  r.approvedLeave,
  r.remainingLeave,
  r.leaveDate,
  r.leaveType,
  ]);

  autoTable(docPDF, {
    head: [["Hotel_ID", "Name", "Total Rooms", "Unavailable Rooms", "Available Rooms", "Date", "Reason"]],
    body: rows,
    startY: 20,
  });

  docPDF.save("Room_records.pdf");
};

    const handleEdit = (record) => {
    setForm({
        hid: record.hid,
        name: record.name,
        totalLeave: record.totalLeave,
        approvedLeave: record.approvedLeave,
        remainingLeave: record.remainingLeave,
        leaveDate: record.leaveDate,
    });
    setIsEditing(true);
    setEditId(record.id);
    };

   

const handleDelete = async (id) => {
  const confirm = window.confirm("Are you sure you want to delete this record?");
  if (!confirm) return;

  await deleteDoc(doc(db, "leaveRecords", id));
  alert("Room record deleted!");

  // Refresh data
  const snapshot = await getDocs(collection(db, "leaveRecords"));
  const records = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  setLeaveRecords(records);
  setFilteredRecords(records);
};



  const paginatedRecords = filteredRecords.slice((currentPage - 1) * recordsPerPage, currentPage * recordsPerPage);
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);

  return (
    <div className="leave-container">
      <h2>Room Management</h2>
      <form onSubmit={handleSubmit} className="leave-form">
        <input type="text" name="hid" placeholder="Hotel ID" value={form.hid} onChange={handleChange} required />
        <input type="text" name="name" placeholder="Hotel Name" value={form.name} readOnly />
        <input type="number" name="totalLeave" placeholder="Total Rooms" value={form.totalLeave} onChange={handleChange} required />
        <input type="number" name="approvedLeave" placeholder="Unavailable Rooms" value={form.approvedLeave} onChange={handleChange} />
        <input type="date" name="leaveDate" value={form.leaveDate} onChange={handleChange} />
        <input type="number" name="remainingLeave" placeholder="Available Rooms" value={form.remainingLeave} readOnly />
        <select name="leaveType" value={form.leaveType} onChange={handleChange} >
          <option value="None">None</option>
          {/* <option value="Reason">Reason</option> */}
          <option value="Reason1">Reason1</option>
          <option value="Reason2">Reason2</option>
          <option value="Reason3">Reason3</option>
          <option value="Reason4">Reason4</option>
          <option value="Reason5">Reason5</option>
        </select>
        <button type="submit">{isEditing ? "Update" : "Submit"}</button>
        <button type="button" onClick={() => setShowTable(!showTable)}>{showTable ? "Hide Details" : "View Details"}</button>
      </form>

      {showTable && (
        <div className="leave-table">
          <div className="controls">
            <input type="text" placeholder="Search by Name or EPF" value={searchTerm} onChange={handleSearch} />
            <button onClick={exportExcel}>Export Excel</button>
            <button onClick={exportPDF}>Export PDF</button>
          </div>
            <div style={{ overflowX: "auto", maxWidth: "100%" }}>
            <table style={{ minWidth: "1000px", borderCollapse: "collapse" }}>
            
            <thead>
              <tr>
                <th onClick={() => handleSort("hid")}>Hotel_ID</th>
                <th onClick={() => handleSort("name")}>Name</th>
                <th>Total Rooms</th>
                <th>Unavailable_rooms</th>
                <th>Available_Rooms</th>
                <th>Reason</th>
                <th onClick={() => handleSort("leaveDate")}> Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
                {paginatedRecords.map(record => (
                    <tr key={record.id}>
                    <td>{record.hid}</td>
                    <td>{record.name}</td>
                    <td>{record.totalLeave}</td>
                    <td>{record.approvedLeave}</td>
                    <td>{record.remainingLeave}</td>
                    <td>{record.leaveType}</td>
                    <td>{record.leaveDate}</td>
                    <td>
                        <button onClick={() => handleEdit(record)}>Edit</button>
                        <button onClick={() => handleDelete(record.id)}>Delete</button>
                    </td>
                    </tr>
                ))}
                </tbody>

          </table>
          </div>
          
          <div className="pagination">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                className={i + 1 === currentPage ? "active" : ""}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* {leaveRequests.map((req, idx) => (
        <div key={idx} className="request-popup">
          <p>Leave Request from {req.epfOrPid} ({req.name})</p>
          <button onClick={() => approveRequest(req)}>Approve</button>
        </div>
      ))} */}
    </div>
  );
};

export default LeaveManagement;
